/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLeaseDocument = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 2v16l-4 .001A5.03 5.03 0 0 1 17 19v4h-6v-4a5.03 5.03 0 0 1-1-.999L2 18V2zm-6.999 17.9A5 5 0 0 1 14 20l.265-.007a5.08 5.08 0 0 1-.53 0l-.066-.004a4.902 4.902 0 0 1-.67-.09L13 21h2zm-1.177-7.895a3 3 0 0 0-2.814 3.242l-.003-.043c.033.448.174.884.412 1.292l.156.27c.184.253.406.475.659.66l.27.155a3 3 0 0 0 1.294.412L14 18a2.794 2.794 0 0 0 .247-.01l-.045.003a2.99 2.99 0 0 0 1.294-.412l.27-.156c.253-.184.475-.406.66-.659l.155-.27a3 3 0 0 0 .412-1.294L17 15a3 3 0 0 0-3-3zM14 10a5 5 0 0 1 4.993 5.265l-.004.066a4.902 4.902 0 0 1-.09.67L20 16V4H4v12l5.1.001a5 5 0 0 1-.088-.651l-.003-.056-.002-.027A5 5 0 0 1 14 10zm2-4v2H8V6z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLeaseDocument as LeaseDocument };
